import { lazy } from 'react';

export const LazyPages = {
  Patrols: {
    Index: lazy(
      () =>
        import(
          /* webpackChunkName: "patrols" */
          '~/pages/Patrols/Patrols'
        ),
    ),
    Active: lazy(
      () =>
        import(
          /* webpackChunkName: "patrols" */
          '~/pages/Patrols/PageActive/PatrolActive'
        ),
    ),
    List: lazy(
      () =>
        import(
          /* webpackChunkName: "patrols" */
          '~/pages/Patrols/PageList/PatrolsList'
        ),
    ),
    Rules: lazy(
      () =>
        import(
          /* webpackChunkName: "patrols" */
          '~/pages/Patrols/PageRules/PatrolsRules'
        ),
    ),
  },

  Treasury: {
    Index: lazy(
      () =>
        import(
          /* webpackChunkName: "treasury" */
          '~/pages/Treasury/Treasury'
        ),
    ),
    Distribution: lazy(
      () =>
        import(
          /* webpackChunkName: "treasury" */
          '~/pages/TreasuryDistribution/TreasuryDistribution'
        ),
    ),
    History: lazy(
      () =>
        import(
          /* webpackChunkName: "treasury" */
          '~/pages/TreasuryHistory/TreasuryHistory'
        ),
    ),
    Rewards: lazy(
      () =>
        import(
          /* webpackChunkName: "treasury" */
          '~/pages/TreasuryRewards/TreasuryRewards'
        ),
    ),
  },

  ClanWars: {
    Index: lazy(
      () =>
        import(
          /* webpackChunkName: "clanwars" */
          '~/pages/ClanWars/ClanWars'
        ),
    ),
    Tabs: {
      Welcome: lazy(
        () =>
          import(
            /* webpackChunkName: "clanwars" */
            '~/pages/ClanWars/ClanWarsWelcome'
          ),
      ),
      Rating: lazy(
        () =>
          import(
            /* webpackChunkName: "clanwars" */
            '~/pages/ClanWars/Tabs/ClanRatingTab/ClanRatingTab'
          ),
      ),
      War: lazy(
        () =>
          import(
            /* webpackChunkName: "clanwars" */
            '~/pages/ClanWars/Tabs/MyWarTab/MyWarTab'
          ),
      ),
      Rules: lazy(
        () =>
          import(
            /* webpackChunkName: "clanwars" */
            '~/pages/ClanWars/Tabs/RulesTab/RulesTab'
          ),
      ),
    },
  },
} as const;
